import React, { Fragment, useEffect, useState, useCallback } from 'react';
import InvoiceForm from './InvoiceForm';
import InvoicePreview from './InvoicePreview';
import Footer from '../Footer/Footer';
import './InvoiceGenerator.css';

function InvoiceGeneratorMain() {
    useEffect(() => {
        document.title = "Invoice Generator | InvoicePoint"
    }, []);

    const [invoiceData, setInvoiceData] = useState({
        client: null,
        items: [],
        subtotal: 0,
        tax: 0,
        total: 0,
        paymentTerms: '14 Days',
        instructions: ''
    });

    const updateInvoiceData = useCallback((data) => {
        setInvoiceData(data);
    }, []);

    return (
        <Fragment>
            <div className="invoice-generator-page">
                <div className="invoice-generator-header">
                    <div className="container">
                        <div className="text-center py-4">
                            <h1 className="h-2 h-bold mb-10">Invoice Generator</h1>
                            <p className="paragraph">Create professional invoices in seconds</p>
                        </div>
                    </div>
                </div>
                <div className="invoice-generator-container">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-5 invoice-form-section">
                                <InvoiceForm 
                                    invoiceData={invoiceData}
                                    updateInvoiceData={updateInvoiceData}
                                />
                            </div>
                            <div className="col-lg-7 invoice-preview-section">
                                <InvoicePreview invoiceData={invoiceData} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </Fragment>
    );
}

export default InvoiceGeneratorMain;
